import React from "react";

import {
  StyledContainer,
  StyledCurrency,
  StyledCurrenyField,
  StyledPriceField,
} from "./PriceCurrenyField.styles";
import { IPriceCurrenyFieldProps } from "./PriceCurrenyField.types";
import Icon from "@/components/misc/Icon";

const PriceCurrenyField: React.FC<IPriceCurrenyFieldProps> = ({
  currency,
  onCurrencyChange,
  price,
  onPriceChange,
  className,
  currenyFieldProps = {},
  priceFieldProps = {},
}) => {
  const showCurreny = !!price;

  return (
    <StyledContainer className={className}>
      {false && (
        <StyledCurrenyField
          {...currenyFieldProps}
          // TO-CHECK: Why input's disabled prop not working
          disabled
          value={currency}
          onChange={onCurrencyChange as any}
          label="Currency"
        />
      )}
      <StyledPriceField
        {...priceFieldProps}
        $showCurreny={showCurreny}
        prependContent={
          <>
            <Icon isSrcRelative src="currency.svg" size="xs" />
            <StyledCurrency className="currency">USD</StyledCurrency>
          </>
        }
        value={price || ""}
        onChange={(value) => onPriceChange(+value)}
        type="number"
        placeholder="Price"
      />
    </StyledContainer>
  );
};

export default PriceCurrenyField;
